import { call, put, takeLatest } from "redux-saga/effects";
import { fetchTestListRequest, fetchTestListSuccess, fetchTestListFailure } from "./testListSlice";
import { getTestListLean } from "../../utils/api-communication/RestApiCli";
import { displayPatientName } from "@utils/CommonUtil";

function* fetchTestListSaga(action) {
  try {
    const query = action.payload;
    const response = yield call(
      () =>
        new Promise((resolve, reject) => {
          getTestListLean(
            query,
            (res) => resolve(res),
            (err) => reject(err),
            () => reject(new Error("Unauthorized")),
          );
        }),
    );
    const selectAll = true;
    const lastPage = response.data.lastPage || 1;
    const filters = response.data.filters || {};
    const enrichedData = (response.data.data || []).map((test) => ({
      ...test,
      patientName: test.patient ? displayPatientName(test.patient.name) : undefined,
      patientDob: test.patient ? test.patient.dob : undefined,
      unSelect: typeof test.unSelect === "boolean" ? test.unSelect : !selectAll,
    }));
    yield put(fetchTestListSuccess({ data: enrichedData, lastPage, filters }));
  } catch (error) {
    yield put(fetchTestListFailure(error.message || "Failed to fetch test list"));
  }
}

export function* watchTestListSaga() {
  yield takeLatest(fetchTestListRequest.type, fetchTestListSaga);
}
